// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-screen {
  min-height: calc(100vh - 32px);
  min-height: calc(var(--dataspace-scaled-vh, 100vh) - 32px);
  display: grid;
  place-items: center;
  padding: 16px 0;
  width: 100%;
}

.login-wrap {
  width: min(980px, 100%);
  max-width: 980px;
  margin: 0 auto;
  border-radius: 26px;
  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.16);
  overflow: hidden;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  position: relative;
}

.login-wrap::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 20% 20%, rgba(59, 130, 246, 0.18), transparent 55%),
    radial-gradient(circle at 80% 0%, rgba(14, 165, 233, 0.15), transparent 45%),
    radial-gradient(circle at 80% 80%, rgba(59, 130, 246, 0.12), transparent 55%);
  pointer-events: none;
}

.login-hero {
  background: linear-gradient(120deg, #0f172a 0%, #0b4ea2 48%, #ffffff 100%);
  padding: 24px;
  color: #fff;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.login-hero-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.login-hero-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.18);
  display: grid;
  place-items: center;
  font-size: 22px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
}

.login-hero-title {
  font-weight: 900;
  font-size: 22px;
  letter-spacing: 0.2px;
}

.login-visual-band {
  height: clamp(336px, 42vw, 456px);
  margin: 14px 16px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  border-radius: 22px;
  background:
    radial-gradient(circle at 48% 35%, rgba(30, 64, 175, 0.28), rgba(30, 64, 175, 0) 42%),
    linear-gradient(180deg, #0b1220 0%, #0f172a 62%, #111827 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.28);
  box-shadow: inset 0 24px 52px rgba(15, 23, 42, 0.38);
}

.login-particle-cloud {
  position: absolute;
  inset: 0;
  cursor: grab;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

.login-particle-cloud.is-dragging {
  cursor: grabbing;
}

.login-particle-cloud canvas {
  width: 100%;
  height: 100%;
  display: block;
}

.login-particle-cloud::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: min(286px, 36%);
  aspect-ratio: 1 / 1;
  transform: translate(-50%, -50%);
  pointer-events: none;
  border: 1px solid rgba(226, 232, 240, 0.16);
  border-radius: 999px;
  background:
    radial-gradient(
      circle at 50% 50%,
      rgba(226, 232, 240, 0.055) 0%,
      rgba(226, 232, 240, 0.025) 58%,
      rgba(226, 232, 240, 0) 72%
    );
  box-shadow:
    inset 0 0 42px rgba(15, 23, 42, 0.45),
    0 0 44px rgba(147, 197, 253, 0.12);
}

.login-particle-cloud__label {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 3;
  transform: translate(-50%, -50%);
  pointer-events: none;
  color: #f8fafc;
  font-size: clamp(13px, 1.55vw, 19px);
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
  white-space: nowrap;
  text-shadow:
    0 0 14px rgba(147, 197, 253, 0.62),
    0 2px 8px rgba(15, 23, 42, 0.95);
}

.login-particle-cloud--fallback {
  background:
    radial-gradient(circle at 35% 42%, rgba(248, 250, 252, 0.74) 0 2px, transparent 3px),
    radial-gradient(circle at 64% 56%, rgba(147, 197, 253, 0.66) 0 2px, transparent 3px),
    linear-gradient(180deg, #0b1220 0%, #111827 100%);
  background-size: 42px 42px, 54px 54px, auto;
}

.login-card {
  padding: 20px 22px 18px;
  background: #fff;
  position: relative;
  z-index: 1;
}

.login-section + .login-section {
  margin-top: 12px;
}

.section-head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 8px;
}

.section-title {
  font-weight: 900;
  color: #0f172a;
  letter-spacing: 0.2px;
}

.provider-grid {
  display: grid;
  grid-gap: 10px;
  gap: 10px;
}

@media (min-width: 680px) {
  .provider-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.prov-card {
  text-align: left;
  width: 100%;
  border: 1px solid #dbe3f3;
  background: #f8fbff;
  border-radius: 18px;
  padding: 14px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  cursor: pointer;
  transition: transform 0.08s, background 0.2s, border-color 0.2s, box-shadow 0.2s;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.05);
}

.prov-card:hover {
  transform: translateY(-2px);
  background: #f1f6ff;
}

.prov-card.active {
  background: #ffffff;
  border-color: #b9d4ff;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15), 0 14px 30px rgba(15, 23, 42, 0.12);
}

.radio {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 2px solid #9ab7e6;
  margin-top: 2px;
  position: relative;
  flex: 0 0 18px;
  background: #fff;
}

.radio.on {
  border-color: #1d4ed8;
}

.radio.on::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 8px;
  height: 8px;
  background: #1d4ed8;
  border-radius: 999px;
  transform: translate(-50%, -50%);
}

.prov-text {
  display: grid;
  grid-gap: 2px;
  gap: 2px;
}

.prov-label {
  font-weight: 800;
  color: #0f172a;
}

.prov-url {
  font-size: 12px;
  color: #64748b;
}

.custom-row {
  position: relative;
}

.custom-input {
  width: 100%;
  padding: 10px 44px 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  outline: none;
  background: #fff;
  color: var(--text);
}

.custom-input:focus {
  border-color: #b9d4ff;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
}

.clear-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 10px;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
}

.login-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
  margin-top: 16px;
}

.login-secondary,
.login-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  height: 42px;
  box-sizing: border-box;
  border: none;
  padding: 0 1.3rem;
  border-radius: 14px;
  font-weight: 800;
  cursor: pointer;
}

.login-primary {
  background: linear-gradient(120deg, #1d4ed8 0%, #2563eb 100%);
  color: #fff;
  box-shadow: 0 12px 26px rgba(37, 99, 235, 0.3);
}

.login-secondary {
  background: #f8fbff;
  color: #1d4ed8;
  border: 1px solid #dbe8ff;
}

.login-secondary:hover {
  background: #eef5ff;
}

.login-primary:disabled,
.login-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.standalone-login-page {
  min-height: 100vh;
  min-height: var(--dataspace-scaled-vh, 100vh);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 80px 20px 40px;
  background:
    radial-gradient(circle at 20% 20%, #e0edff 0%, transparent 55%),
    radial-gradient(circle at 80% 0%, #f8f0ff 0%, transparent 45%),
    #f8fafc;
}

@media (max-width: 560px) {
  .login-hero {
    gap: 12px;
  }

  .login-visual-band {
    height: 312px;
    margin: 12px;
    border-radius: 20px;
  }

  .login-footer {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .login-primary {
    min-width: 108px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/LoginScreen.css"],"names":[],"mappings":"AAAA;EACE,8BAA0D;EAA1D,0DAA0D;EAC1D,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;iFAG+E;EAC/E,oBAAoB;AACtB;;AAEA;EACE,0EAA0E;EAC1E,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB;;kEAEgE;EAChE,kDAAkD;EAClD,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,2CAA2C;EAC3C,oBAAoB;EACpB;;;;;;KAMG;EACH;;sCAEoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,oBAAoB;EACpB,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB;;oCAEkC;AACpC;;AAEA;EACE;;;qDAGmD;EACnD,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gFAAgF;EAChF,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kFAAkF;AACpF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,aAAQ;EAAR,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAA6C;EAA7C,6CAA6C;EAC7C,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB;;;WAGS;AACX;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,0CAA0C;EAC5C;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".login-screen {\n  min-height: calc(var(--dataspace-scaled-vh, 100vh) - 32px);\n  display: grid;\n  place-items: center;\n  padding: 16px 0;\n  width: 100%;\n}\n\n.login-wrap {\n  width: min(980px, 100%);\n  max-width: 980px;\n  margin: 0 auto;\n  border-radius: 26px;\n  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.16);\n  overflow: hidden;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  position: relative;\n}\n\n.login-wrap::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(circle at 20% 20%, rgba(59, 130, 246, 0.18), transparent 55%),\n    radial-gradient(circle at 80% 0%, rgba(14, 165, 233, 0.15), transparent 45%),\n    radial-gradient(circle at 80% 80%, rgba(59, 130, 246, 0.12), transparent 55%);\n  pointer-events: none;\n}\n\n.login-hero {\n  background: linear-gradient(120deg, #0f172a 0%, #0b4ea2 48%, #ffffff 100%);\n  padding: 24px;\n  color: #fff;\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n}\n\n.login-hero-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.login-hero-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.18);\n  display: grid;\n  place-items: center;\n  font-size: 22px;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  backdrop-filter: blur(6px);\n}\n\n.login-hero-title {\n  font-weight: 900;\n  font-size: 22px;\n  letter-spacing: 0.2px;\n}\n\n.login-visual-band {\n  height: clamp(336px, 42vw, 456px);\n  margin: 14px 16px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  border-radius: 22px;\n  background:\n    radial-gradient(circle at 48% 35%, rgba(30, 64, 175, 0.28), rgba(30, 64, 175, 0) 42%),\n    linear-gradient(180deg, #0b1220 0%, #0f172a 62%, #111827 100%);\n  border-bottom: 1px solid rgba(148, 163, 184, 0.28);\n  box-shadow: inset 0 24px 52px rgba(15, 23, 42, 0.38);\n}\n\n.login-particle-cloud {\n  position: absolute;\n  inset: 0;\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n}\n\n.login-particle-cloud.is-dragging {\n  cursor: grabbing;\n}\n\n.login-particle-cloud canvas {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.login-particle-cloud::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: min(286px, 36%);\n  aspect-ratio: 1 / 1;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  border: 1px solid rgba(226, 232, 240, 0.16);\n  border-radius: 999px;\n  background:\n    radial-gradient(\n      circle at 50% 50%,\n      rgba(226, 232, 240, 0.055) 0%,\n      rgba(226, 232, 240, 0.025) 58%,\n      rgba(226, 232, 240, 0) 72%\n    );\n  box-shadow:\n    inset 0 0 42px rgba(15, 23, 42, 0.45),\n    0 0 44px rgba(147, 197, 253, 0.12);\n}\n\n.login-particle-cloud__label {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 3;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n  color: #f8fafc;\n  font-size: clamp(13px, 1.55vw, 19px);\n  font-weight: 900;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  text-align: center;\n  white-space: nowrap;\n  text-shadow:\n    0 0 14px rgba(147, 197, 253, 0.62),\n    0 2px 8px rgba(15, 23, 42, 0.95);\n}\n\n.login-particle-cloud--fallback {\n  background:\n    radial-gradient(circle at 35% 42%, rgba(248, 250, 252, 0.74) 0 2px, transparent 3px),\n    radial-gradient(circle at 64% 56%, rgba(147, 197, 253, 0.66) 0 2px, transparent 3px),\n    linear-gradient(180deg, #0b1220 0%, #111827 100%);\n  background-size: 42px 42px, 54px 54px, auto;\n}\n\n.login-card {\n  padding: 20px 22px 18px;\n  background: #fff;\n  position: relative;\n  z-index: 1;\n}\n\n.login-section + .login-section {\n  margin-top: 12px;\n}\n\n.section-head {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.section-title {\n  font-weight: 900;\n  color: #0f172a;\n  letter-spacing: 0.2px;\n}\n\n.provider-grid {\n  display: grid;\n  gap: 10px;\n}\n\n@media (min-width: 680px) {\n  .provider-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.prov-card {\n  text-align: left;\n  width: 100%;\n  border: 1px solid #dbe3f3;\n  background: #f8fbff;\n  border-radius: 18px;\n  padding: 14px;\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  cursor: pointer;\n  transition: transform 0.08s, background 0.2s, border-color 0.2s, box-shadow 0.2s;\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.05);\n}\n\n.prov-card:hover {\n  transform: translateY(-2px);\n  background: #f1f6ff;\n}\n\n.prov-card.active {\n  background: #ffffff;\n  border-color: #b9d4ff;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15), 0 14px 30px rgba(15, 23, 42, 0.12);\n}\n\n.radio {\n  width: 18px;\n  height: 18px;\n  border-radius: 999px;\n  border: 2px solid #9ab7e6;\n  margin-top: 2px;\n  position: relative;\n  flex: 0 0 18px;\n  background: #fff;\n}\n\n.radio.on {\n  border-color: #1d4ed8;\n}\n\n.radio.on::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 8px;\n  height: 8px;\n  background: #1d4ed8;\n  border-radius: 999px;\n  transform: translate(-50%, -50%);\n}\n\n.prov-text {\n  display: grid;\n  gap: 2px;\n}\n\n.prov-label {\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.prov-url {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.custom-row {\n  position: relative;\n}\n\n.custom-input {\n  width: 100%;\n  padding: 10px 44px 10px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  outline: none;\n  background: #fff;\n  color: var(--text);\n}\n\n.custom-input:focus {\n  border-color: #b9d4ff;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);\n}\n\n.clear-btn {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 10px;\n  background: #f1f5f9;\n  color: #64748b;\n  cursor: pointer;\n}\n\n.login-footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: nowrap;\n  margin-top: 16px;\n}\n\n.login-secondary,\n.login-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.55rem;\n  height: 42px;\n  box-sizing: border-box;\n  border: none;\n  padding: 0 1.3rem;\n  border-radius: 14px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.login-primary {\n  background: linear-gradient(120deg, #1d4ed8 0%, #2563eb 100%);\n  color: #fff;\n  box-shadow: 0 12px 26px rgba(37, 99, 235, 0.3);\n}\n\n.login-secondary {\n  background: #f8fbff;\n  color: #1d4ed8;\n  border: 1px solid #dbe8ff;\n}\n\n.login-secondary:hover {\n  background: #eef5ff;\n}\n\n.login-primary:disabled,\n.login-secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.standalone-login-page {\n  min-height: var(--dataspace-scaled-vh, 100vh);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 80px 20px 40px;\n  background:\n    radial-gradient(circle at 20% 20%, #e0edff 0%, transparent 55%),\n    radial-gradient(circle at 80% 0%, #f8f0ff 0%, transparent 45%),\n    #f8fafc;\n}\n\n@media (max-width: 560px) {\n  .login-hero {\n    gap: 12px;\n  }\n\n  .login-visual-band {\n    height: 312px;\n    margin: 12px;\n    border-radius: 20px;\n  }\n\n  .login-footer {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n  }\n\n  .login-primary {\n    min-width: 108px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
